<script lang="ts">
  import { SvelteComponent } from "svelte";
  import {
    Themes,
    NavMinimizationTogglerPositions,
    NavDirections,
    Pages,
  } from "../../utils/enums";
  import { type TExpandedNavProps, type TNavConfig, type TTheme } from "../../utils/types";
  import MainNavItem from "./MainNavItem.svelte";
  import MinimizationToggler from "./MinimizationToggler.svelte";

  export let options: {
    isExpanded: boolean;
    theme: TTheme;
    isMinimized: boolean;
    cssVarStyles: string;
    navConfig: TNavConfig;
    navDirection: string;
    iconStyles: string;
    onItemClicked: (page: Pages) => void;
    expandedNavComponent: typeof SvelteComponent<{ options: TExpandedNavProps }>
    navbarOverrideImage?: string;
  };
  export let navItemOptions: {
    onClick: () => void;
    title: string;
    passIcon: string;
    chevronStyles: string;
  };

  export let balanceOptions: {
    isShown: boolean;
    balance: string;
  };
  let isMinimized = options.isMinimized;

  $: theme = options.theme;
  $: cssVarStyles = options.cssVarStyles;
  $: navConfig = options.navConfig;
  $: navDirection = options.navDirection;
  $: iconStyles = options.iconStyles;
  $: onItemClicked = options.onItemClicked;
  $: expandedNavComponent = options.expandedNavComponent;
  $: isExpanded = options.isExpanded;
  $: navbarOverrideImage = options.navbarOverrideImage;
  $: hasNavbarOverride = !!navbarOverrideImage;

  $: balance = balanceOptions.balance;
  $: isShownBalance = balanceOptions.isShown;
  $: chevronStyles = navItemOptions.chevronStyles;

  $: expandedOptions = {
    isMinimized: hasNavbarOverride ? false : isMinimized,
    theme,
    iconStyles,
    onClick: onItemClicked,
    isShownBalance,
    balance,
  };
</script>

<div class="crdz-ui" id="cpnav">
  {#if hasNavbarOverride}
    <div
      class="cpnav crtw-fixed crtw-z-50 crtw-flex crtw-flex-col crtw-items-center crtw-justify-center
      crtw-font-[poppins] crtw-text-xs crtw-cursor-pointer"
      style={cssVarStyles}
    >
      {#if navDirection === NavDirections.TOP && isExpanded}
        <div
          class="crtw-w-56 crtw-flex crtw-flex-col crtw-items-center crtw-justify-center crtw-bg-white crtw-text-gray-800
          crtw-border crtw-border-gray-700 crtw-rounded crtw-pr-1.5 crtw-mb-1"
          class:crtw-bg-black={theme === Themes.BLACK}
          class:crtw-text-white={theme === Themes.BLACK}
        >
          <svelte:component this={expandedNavComponent} options={expandedOptions} />
        </div>
      {/if}

      <MainNavItem
        options={{
          ...navItemOptions,
          theme,
          isMinimized: false,
          chevronStyles,
          navbarOverrideImage,
        }}
      />

      {#if navDirection === NavDirections.BOTTOM && isExpanded}
        <div
          class="crtw-w-56 crtw-flex crtw-flex-col crtw-items-center crtw-justify-center crtw-bg-white crtw-text-gray-800
          crtw-border crtw-border-gray-700 crtw-rounded crtw-pr-1.5 crtw-mt-1"
          class:crtw-bg-black={theme === Themes.BLACK}
          class:crtw-text-white={theme === Themes.BLACK}
        >
          <svelte:component this={expandedNavComponent} options={expandedOptions} />
        </div>
      {/if}
    </div>
  {:else}
    <div
      class="cpnav crtw-fixed crtw-z-50 crtw-w-56 crtw-flex crtw-flex-col crtw-items-center crtw-justify-center crtw-bg-white crtw-text-gray-800
      crtw-font-[poppins] crtw-text-xs crtw-border crtw-border-gray-700 crtw-rounded crtw-cursor-pointer crtw-pr-1.5"
      class:crtw-bg-black={theme === Themes.BLACK}
      class:crtw-text-white={theme === Themes.BLACK}
      class:crtw-w-[70px]={isMinimized}
      class:crtw-pr-5={navConfig.minimization?.toggler?.enabled &&
        navConfig.minimization?.toggler?.position ===
          NavMinimizationTogglerPositions.RIGHT}
      class:crtw-pl-5={navConfig.minimization?.toggler?.enabled &&
        navConfig.minimization?.toggler?.position !==
          NavMinimizationTogglerPositions.RIGHT}
      style={cssVarStyles}
    >
      <MinimizationToggler {theme} {navConfig} bind:isMinimized />

      {#if navDirection === NavDirections.TOP && isExpanded}
        <svelte:component this={expandedNavComponent} options={expandedOptions} />
      {/if}

      <MainNavItem
        options={{ ...navItemOptions, theme, isMinimized, chevronStyles }}
      />

      {#if navDirection === NavDirections.BOTTOM && isExpanded}
        <svelte:component this={expandedNavComponent} options={expandedOptions} />
      {/if}
    </div>
  {/if}
</div>
